<template>
    <Transition name="pop">
        <div id="SuccessPop" class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>预约成功</h1>
                <div class="tips" v-if="state.role > 0">恭喜您预约成功！</div>
                <div class="tips" v-else>
                    未识别到您在“乘风破浪-先驱”的角色，赶紧前往《新英雄年代》客户端创建角色吧！
                </div>
                <a
                    href="https://xyx.web.sdo.com/web6/download.html"
                    target="_blank"
                    class="download"
                    >立即下载</a
                >
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive } from "vue";

const state = reactive({
    show: false,
    role: ""
});

defineExpose({
    Show: (role = 0) => {
        state.show = true;
        state.role = role;
    }
});
</script>

<style lang="scss" scoped>
#SuccessPop {
    .tips {
        text-align: center;
        width: 400px;
        margin: 0px auto 20px auto;
        line-height: 1.4;
    }
    .download {
        text-decoration: none;
        display: block;
        width: 240px;
        height: 50px;
        margin: 0px auto 20px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
</style>
